//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    primaryPhotoUrl() {
      if (this.$auth.isAGuardianOnBehalfMinor()) {
        return this.user.guardianAthlete?.photo
      } else {
        return this.user.athlete?.photo
      }
    },
    hasSecondaryPhoto() {
      // Secondary photo only appears when it's a guardian navigating on behalf minor.
      return this.$auth.isAGuardianOnBehalfMinor()
    },
    secondaryPhotoUrl() {
      return this.user.athlete?.photo
    },
    greetingName() {
      if (this.user.athlete) {
        return this.user.athlete.greetingName
      } else if (this.user.guardianship) {
        return this.user.guardianship.athleteName
      } else if (this.user.guardian) {
        return this.user.guardian.name
      } else {
        return this.user?.email
      }
    },
    user() {
      return this.$auth.user
    }
  }
}
